import React from "react"
import { Button, Form } from "react-bootstrap"
import { browserHistory } from "react-router"

import apiServerApi from "../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../lib/blockingFetch"
import FontAwesome from "react-fontawesome"
import ProcessesStatus from "../fragments/ProcessesStatus"
import { 
  Currencies,
  validateTextState,
  validateAmountState,
  VALIDATION_TYPE,
  validatePercentState,
  getDefaultCurrency,
  saveDefaultCurrency
} from "../../lib/utils"
import FormControlInlineSelect from "../fragments/FormControl.Inline.Select"
import FormControlInlineInput from "../fragments/FormControl.Inline.Input"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"

const ChargeTimeTypes = [
  { value: '1', title: 'Disbursement' },
  { value: '2', title: 'Specified Due Date' },
]

const ChargeCalculationTypes = [
  { value: '1', title: 'Flat' },
  { value: '2', title: '% of Amount' },
]

const Statuses = [
  { value: 'true', title: 'Active' },
  { value: 'false', title: 'Inactive' },
]

class FormCharge extends React.Component {

  constructor(props) {

    super(props)
    const { charge } = this.props,
    isNew = !charge

    this.state = {
      isNew,
      running: false,
      success: false,
      error: null,
      name: isNew ? '' : charge.name,
      currencyCode: isNew ? getDefaultCurrency() : charge.currencyCode,
      chargeTimeType: isNew ? '1' : charge.chargeTimeType + '',
      chargeCalculationType: isNew ? '1' : charge.chargeCalculationType + '',
      amount: isNew ? '' : charge.amount.toString(),
      active: !isNew && charge.active === false ? 'false' : 'true',

      activeValidationState: VALIDATION_TYPE.SUCCESS,
      nameValidationState: VALIDATION_TYPE.NULL,
      currencyCodeValidationState: VALIDATION_TYPE.SUCCESS,
      chargeTimeTypeValidationState: VALIDATION_TYPE.SUCCESS,
      chargeCalculationTypeValidationState: VALIDATION_TYPE.SUCCESS,
      amountValidationState: VALIDATION_TYPE.NULL,
    }
  }

  componentDidMount() {
    const { isNew } = this.state
    if(!isNew) {
      this.validateAllValues()
    }
  }

  nameChanged = name => this.setState({
    name,
    nameValidationState: validateTextState(name, false),
    error: null,
  })

  activeChanged = active => this.setState({
    active,
    activeValidationState: validateTextState(active, false),
    error: null,
  })

  currencyCodeChanged = currencyCode => this.setState({
    currencyCode,
    currencyCodeValidationState: validateTextState(currencyCode, false),
    error: null,
  })

  chargeTimeTypeChanged = chargeTimeType => this.setState({
    chargeTimeType,
    chargeTimeTypeValidationState: validateTextState(chargeTimeType, false),
    error: null,
  })

  chargeCalculationTypeChanged = chargeCalculationType => {

    const { amount } = this.state,
    amountValidationState = amount 
      ? this.validateAmount(amount, chargeCalculationType) 
      : VALIDATION_TYPE.NULL

    this.setState({
      chargeCalculationType,
      chargeCalculationTypeValidationState: validateTextState(chargeCalculationType, false),
      amountValidationState,
      error: null,
    })
  }

  validateAmount = (amount, chargeCalculationType) =>
    chargeCalculationType === '1' 
      ? validateAmountState(amount, false)
      : validatePercentState(amount, false)

  amountChanged = amount => {

    const { chargeCalculationType } = this.state
    this.setState({
      amount,
      amountValidationState: this.validateAmount(amount, chargeCalculationType),
      error: null,
    })
  }

  validateAllValues = () => {

    const { active, name, currencyCode, chargeTimeType, chargeCalculationType, amount } = this.state
    this.setState({
      activeValidationState: validateTextState(active, false),
      nameValidationState: validateTextState(name, false),
      currencyCodeValidationState: validateTextState(currencyCode, false),
      chargeTimeTypeValidationState: validateTextState(chargeTimeType, false),
      chargeCalculationTypeValidationState: validateTextState(chargeCalculationType, false),
      amountValidationState: this.validateAmount(amount, chargeCalculationType),
    })
  }

  valid = () => {

    const { active, name, currencyCode, chargeTimeType, chargeCalculationType, amount } = this.state
    return (
      validateTextState(active, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(name, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(currencyCode, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(chargeTimeType, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(chargeCalculationType, false) === VALIDATION_TYPE.SUCCESS &&
      this.validateAmount(amount, chargeCalculationType) === VALIDATION_TYPE.SUCCESS
    )
  }

  saveClicked = () => {

    if(this.valid()) {
      this.saveCharge()
    }
    else {
      this.validateAllValues()
      this.setState({ error: 'Some fields are incorrect.' })
    }
  }

  saveCharge = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, active, name, currencyCode, chargeTimeType, chargeCalculationType, amount } = this.state,
    data = { active, name, currencyCode, chargeTimeType, chargeCalculationType, amount },
    { charge } = this.props

    saveDefaultCurrency(currencyCode)

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.createLoanCharge(accessToken, data)
        : apiServerApi.updateLoanCharge(accessToken, charge.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push('/charges'), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderForm = () => {
    const { isNew, error, success, running, active, name, currencyCode, chargeTimeType,
      chargeCalculationType, amount, activeValidationState, nameValidationState, currencyCodeValidationState,
      chargeTimeTypeValidationState, chargeCalculationTypeValidationState, amountValidationState } = this.state

    return (
      <div className="simple-form max-width-700 mx-auto mb-20">
        <Form horizontal onSubmit={e => { e.preventDefault(); this.saveClicked()}}>

          <h3 className="text-center">
            { isNew ? 'New charge' : 'Update charge' }
          </h3>
          <hr />

          <FormControlInlineSelect
            controlId='status' validationState={ activeValidationState }
            label='Status' value={ active } 
            onChange={ this.activeChanged }
            options={ Statuses }
          />

          <FormControlInlineInput controlId="name" validationState={ nameValidationState }
            label='Name' placeholder='Enter name' value={ name }
            onChange={ this.nameChanged }
            helpText={ nameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
          />

          <FormControlInlineSelect
            controlId='currencyCode' validationState={ currencyCodeValidationState }
            label='Currency' value={ currencyCode } 
            onChange={ this.currencyCodeChanged }
            options={ Currencies }
          />

          <FormControlInlineSelect
            controlId='chargeTimeType' validationState={ chargeTimeTypeValidationState }
            label='Charge Time Type' value={ chargeTimeType } 
            onChange={ this.chargeTimeTypeChanged }
            options={ ChargeTimeTypes }
          />

          <FormControlInlineSelect
            controlId='chargeCalculationType' validationState={ chargeCalculationTypeValidationState }
            label='Charge Calculation Type' value={ chargeCalculationType } 
            onChange={ this.chargeCalculationTypeChanged }
            options={ ChargeCalculationTypes }
          />

          <FormControlInlineInput controlId="amount" validationState={ amountValidationState }
            label={ `Amount (${ chargeCalculationType === '1' ? currencyCode : '%' })` } 
            placeholder={ chargeCalculationType === '1' ? `${currencyCode} amount` : '% of amount' }
            value={ amount } onChange={ this.amountChanged }
            helpText={ amountValidationState === VALIDATION_TYPE.ERROR ? 'Provided value is incorrect!' : '' }
          />
        </Form>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <div className="align-right mt-30">
          <Button onClick={() => browserHistory.push('/charges')} className="w-100" disabled={ running }>
            <FontAwesome name='close' /> Cancel
          </Button>

          &nbsp; &nbsp;
          <Button bsStyle="success" onClick={ this.saveClicked } className="w-120" disabled={ running }>
            <FontAwesome name='save' /> Save
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const { isNew } = this.state,
    data = [{ url: '/charges', title: 'Charges' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ data } />
        { this.renderForm() }
      </div>
    )
  }
}

export default FormCharge



// WEBPACK FOOTER //
// ./src/components/Charges/Form.js